import { unstableSetRender } from 'antd-mobile/es/utils/unstable-render'
import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './App.tsx'
import './index.css'

async function enableMocking() {
  if (!import.meta.env.DEV) return;
  const { worker } = await import('./mocks/browser');
  return worker.start({
    onUnhandledRequest: 'bypass',
  });
}

// React 19 兼容性配置
// 參考: https://mobile.ant.design/zh/guide/v5-for-19
// 設置 antd-mobile 的 React 19 兼容渲染函數
unstableSetRender((node, container) => {
  const root = createRoot(container);
  root.render(node);
  return async () => {
    root.unmount();
  };
});

// 完全阻止 clipboard.min.js 錯誤影響應用
const originalConsoleError = console.error;
console.error = (...args) => {
  const message = args.join(' ');
  if (
    message.includes('clipboard.min.js') || 
    message.includes('Cannot use import statement outside a module')
  ) {
    console.warn('🚫 Blocked external error:', message);
    return;
  }
  originalConsoleError.apply(console, args);
};

// 攔截所有錯誤事件
window.addEventListener('error', (event) => {
  if (event.filename && (
    event.filename.includes('clipboard.min.js') ||
    event.filename.includes('chrome-extension://') ||
    event.filename.includes('moz-extension://')
  )) {
    event.preventDefault();
    event.stopPropagation();
    console.warn('🚫 Blocked external script error:', event.message);
    return false;
  }
  return true;
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason?.toString() || '';
  if (reason.includes('clipboard.min.js') || reason.includes('Cannot use import statement outside a module')) {
    event.preventDefault();
    console.warn('🚫 Blocked external promise rejection:', reason);
    return;
  }
});

// 攔截全局錯誤
window.onerror = (message, source) => {
  if (source && source.includes('clipboard.min.js')) {
    console.warn('🚫 Blocked global clipboard error:', message);
    return true; // 阻止錯誤冒泡
  }
  return false;
};

enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
